<template>
  <div class="editorContainer">
    <span
      class="editor-caption caption v-label theme--light"
      :class="{ 'error--text': error }" >
      <span>{{ label }} <span v-if="required">*</span></span>{{ $t('news.item.steplang.formatta') }}</span>
    <div ref="editor"></div>
    <div class="editor-messages">
      <div
        class="error--text caption"
        ><span v-if="this.error">{{ error }}</span></div>
      <div class="v-counter theme--light">{{ characterCount }}</div>
    </div>
  </div>
</template>

<script>

/*
* basato su Quill
* https://quilljs.com/
*/

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import Quill from 'quill'

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean
    },
    required: {
      type: Boolean
    },
    maxLength: {
      type: Number
    },
    minLength: {
      type: Number
    },
    value: {
      required: true
    }
  },
  data: () => ({
    error: false,
    quill: null,
    html: null,
    editorOptions: {
      theme: 'bubble',
      placeholder: '',
      spellcheck: false,
      bounds: '.editorContainer',
      modules: {
        toolbar: [
          ['bold'],
          [{ list: 'bullet' }]
        ]
      }
    }
  }),
  computed: {
    text () {
      return this.quill ? this.quill.getText().trim() : null
    },
    characterCount () {
      return this.text ? this.text.length : 0
    },
  },
  watch: {
    text: function (newVal, oldVal) {
      if (newVal.length === 0 && this.required) {
        this.error = 'Obbligatorio'
      } else if (this.maxLength && newVal.length > this.maxLength) {
        this.error = `Massimo ${this.maxLength} caratteri`
      } else if (this.minLength && newVal.length < this.minLength) {
        this.error = `Minimo ${this.minLength} caratteri`
      } else {
        this.error = false
      }
      if (this.error) {
        this.$emit('editor:valid', false)
      } else {
        this.$emit('editor:valid', true)
      }
    },
    value: function (newVal, oldVal) {
      if (newVal && newVal !== this.html) {
        this.html = newVal
        this.quill.root.innerHTML = newVal
      }
    }
  },
  mounted () {
    this.html = this.value
    this.editorOptions.placeholder = this.$t('news.item.steplang.hint1');
    this.quill = new Quill(this.$refs.editor, this.editorOptions)
    this.quill.root.spellcheck = false
    this.quill.pasteHTML(this.html || '')
    this.quill.on('text-change', (delta, oldDelta, source) => {
      this.html = this.quill.root.innerHTML
      this.$emit('input', this.quill.root.innerHTML)
      this.$emit('editor:text', this.text)
    })
    this.quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => { // pulisci da tutto quando incolli
      const ops = []
      delta.ops.forEach(op => {
        if (op.insert && typeof op.insert === 'string') {
          ops.push({
            insert: op.insert
          })
        }
      })
      delta.ops = ops
      return delta
    })
    this.quill.root.addEventListener('blur', () => {
      this.$emit('blur')
    })
  },
  beforeDestroy () {
    this.quill = null
    delete this.quill
  }
}
</script>

<style>
  .editorContainer {
    padding-top: 12px; /* usa la stessa spaziatura degli input di vuetify */
    margin-bottom:24px;
  }
  .editor-messages {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }
  .editor-caption {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  .ql-container {
    font-family: inherit!important; /* eredita i font */
    font-size: 16px!important;
  }
  .ql-editor {
    padding: 0 0 24px 0!important;
    border-bottom: 1px solid rgba(0,0,0,0.42);
  }
  .invalid .ql-editor {
    border-bottom: 1px solid var(--v-error-base);
  }
  .ql-tooltip {
    z-index: 100000!important; /* sopra tutto */
  }
  .ql-editor.ql-blank::before { /* placeholder a sinistra */
    left: 0!important;
  }
</style>
